

import React, { memo } from 'react';
import { useGoogleLogout, useGoogleLogin } from 'react-google-login';
import { Button } from '../../../ui-kit';
import YOUTUBE from '../constants/youtube';








function GoogleButton({ disabled, isSigned, onLogoutSuccess, onLoginSuccess }) {
  const { signIn } = useGoogleLogin({
    onAutoLoadFinished: Function.prototype,
    onFailure: Function.prototype,
    onRequest: Function.prototype,
    onSuccess: onLoginSuccess,
    clientId: YOUTUBE.CLIENT_ID,
    scope: YOUTUBE.UPLOAD_SCOPE,
    accessType: YOUTUBE.ACCESS_TYPE,
    responseType: YOUTUBE.RESPONSE_TYPE
  });

  const { signOut } = useGoogleLogout({
    onLogoutSuccess,
    clientId: YOUTUBE.CLIENT_ID
  });

  const props = {
    disabled,
    type: 'TERTIARY',
    prefix: 'google',
    onClick: isSigned ? signOut : signIn
  };

  return (
    <Button {...props}>{isSigned ? 'Logout' : 'Login'}</Button>);

}

export default memo(GoogleButton);